import Loadable from 'react-loadable';

import LoadableLoadingPage from 'pages/LoadableLoadingPage';

// eslint-disable-next-line import/no-default-export
export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ContentPageContainer" */
      './ContentPageContainerContainer'
    ),
  loading: LoadableLoadingPage,
});
